import { useState } from 'react';
import useReveal from './useReveal';
import Tag from './Tag';
import { projects } from '../data';

function ProjectCard({ project, delay }) {
  const [ref, visible] = useReveal();
  const [hov, setHov] = useState(false);
  const { num, category, title, desc, tags, link, featured } = project;
  const borderColor = hov
    ? (featured ? 'rgba(255,77,109,0.45)' : 'rgba(0,229,255,0.35)')
    : (featured ? 'rgba(255,77,109,0.2)'  : '#1a3040');

  return (
    <div ref={ref} onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{ background: '#0f1c24', border: `1px solid ${borderColor}`, overflow: 'hidden', transition: 'transform 0.25s, border-color 0.2s', transform: visible ? (hov ? 'translateY(-4px)' : 'none') : 'translateY(30px)', opacity: visible ? 1 : 0, transitionDelay: `${delay}ms` }}>
      <div style={{ padding: '2rem 2rem 1.5rem', borderBottom: '1px solid #1a3040', background: '#0b1318', position: 'relative' }}>
        <div style={{ position: 'absolute', top: '1.5rem', right: '1.5rem', fontFamily: "'Space Mono', monospace", fontSize: '2rem', fontWeight: 700, color: featured ? 'rgba(255,77,109,0.08)' : 'rgba(0,229,255,0.08)', lineHeight: 1 }}>{num}</div>
        <div style={{ fontFamily: "'Space Mono', monospace", fontSize: '0.65rem', color: featured ? '#ff4d6d' : '#00e5ff', letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: '0.5rem' }}>{category}</div>
        <div style={{ fontSize: '1.15rem', fontWeight: 700, color: '#e2f0f5' }}>{title}</div>
      </div>
      <div style={{ padding: '1.5rem 2rem 2rem' }}>
        <p style={{ fontSize: '0.88rem', color: '#5a8a9f', lineHeight: 1.8, marginBottom: '1.2rem' }}>{desc}</p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem', marginBottom: link ? '1.5rem' : 0 }}>
          {tags.map(t => <Tag key={t.label} label={t.label} color={t.color} />)}
        </div>
        {link && (
          <a href={link} target="_blank" rel="noreferrer"
            style={{ fontFamily: "'Space Mono', monospace", fontSize: '0.7rem', color: '#00e5ff', textDecoration: 'none', letterSpacing: '0.1em', textTransform: 'uppercase', borderBottom: '1px solid rgba(0,229,255,0.3)', paddingBottom: 1, transition: 'border-color 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.borderColor = '#00e5ff'}
            onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(0,229,255,0.3)'}>
            Voir sur GitHub →
          </a>
        )}
      </div>
    </div>
  );
}

export default function Projects() {
  return (
    <section id="projects" style={{ position: 'relative', zIndex: 1 }}>
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '6rem 3rem' }}>
        <div style={{ fontFamily: "'Space Mono', monospace", fontSize: '0.7rem', color: '#00e5ff', letterSpacing: '0.25em', textTransform: 'uppercase', marginBottom: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
          03 // Projets
          <span style={{ flex: 1, maxWidth: 80, height: 1, background: '#00e5ff', opacity: 0.4 }} />
        </div>
        <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3.2rem)', fontWeight: 800, lineHeight: 1.1, letterSpacing: '-0.02em', marginBottom: '3rem', color: '#e2f0f5' }}>
          Ce que j'ai <span style={{ color: '#00e5ff' }}>construit</span>
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '1.5rem' }}>
          {projects.map((p, i) => <ProjectCard key={p.num} project={p} delay={i * 80} />)}
        </div>
      </div>
    </section>
  );
}
